<!-- 
程式：ODAVFZ99.vue
功能：活動人數累計頁
作者：i9400520
完成：2021-02-09
-->
<template>
  <div>loading...</div>
</template>
<script>
import DTODAV03 from "@/service/DTODAV03.js";

export default {
  name: "ODAVFZ99",
  data() {
    return {};
  },
  mounted() {
    const req = {
      act_id: this.$route.query.act_id,
      event_id: this.$route.query.event_id,
      event_type: this.$route.query.event_type
    };

    //20210330 因網投專站活動insert改調整為後端post進行計數，故註解原先會員判斷部分
    //if (req.act_id === "event20210305") {
    //  this.insertEvent20210305(req);
    //} else {
      this.insertEventAction(req);
    //}
  },
  methods: {
    insertEventAction(req) {
      this.$cathayAxios.post(DTODAV03.insertEventAction, req).then(resp => {
        if (resp.returnCode === 0) {
          // success
        }
      });
    }/*,
    insertEvent20210305(req) {
      const Vue = this;
      
      window.doOC_SSO = function(OC_Token) {
        Vue.$OCBean.doOC_SSO(OC_Token).then(resp => {
          // 實作登入後要做的事情…
          if (resp) {
            // 登入成功，執行insertEvent
            Vue.insertEventAction(req);
          }
        });
      };

      this.$OCBean.insertIframeJs().then(resp => {
        if (resp) {
          // 執行會員登入
          this.$OCBean.hiddenLogin();
        }
      });
    }*/
  }
};
</script>
